import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const DifficultyLevel = ({ levels, selectLevel }) => (
	<div className={styles.DifficultyLevel}>
		<div className={styles.DifficultyLevel__Title}>
			Выберите уровень сложности
		</div>
		{levels.map((level) => (
			<button
				type="button"
				key={level.name}
				className={styles.DifficultyLevel__Button}
				onClick={() => selectLevel(level.name)}
			>
				<div className={styles.DifficultyLevel__Title}>{level.title}</div>
				{level.description && (
					<div className={styles.DifficultyLevel__Description}>
						{level.description}
					</div>
				)}
			</button>
		))}
	</div>
);

DifficultyLevel.propTypes = {
	levels: PropTypes.array,
	selectLevel: PropTypes.func
};

export default DifficultyLevel;
